class MenuHandler {
    constructor() {
      this.menuItems = document.querySelectorAll('.menu-item-has-children');
      this.isMobile = window.innerWidth < 992;
      this.init();
      this.handleResize();
    }
  
    init() {
      this.injectSVGs();
      this.setCurrentParent();
      this.bindEvents();
    }
  
    injectSVGs() {
      const arrowSVG = `
        <svg class="submenu-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.41 0.295L6 4.875L10.59 0.295L12 1.705L6 7.705L0 1.705L1.41 0.295Z" fill="currentColor"/>
        </svg>
      `;
  
      this.menuItems.forEach(item => {
        const link = item.querySelector('a');
        link.insertAdjacentHTML('beforeend', arrowSVG);
      });
    }
  
    setCurrentParent() {
      const currentItem = document.querySelector('.sub-menu .current_page_item');
      if (currentItem) {
        const parentItem = currentItem.closest('.menu-item-has-children');
        if (parentItem) {
          parentItem.classList.add('current_page_item');
        }
      }
    }
  
    handleMobileClick(e) {
      const parentItem = e.target.closest('.menu-item-has-children');
      if (!parentItem) return;
  
      // Empêcher la navigation sur les éléments parents
      e.preventDefault();
      
      const subMenu = parentItem.querySelector('.sub-menu');
      if (!subMenu) return;
      
      parentItem.classList.toggle('submenu-open');
      
      const isOpen = parentItem.classList.contains('submenu-open');
      subMenu.style.display = isOpen ? 'flex' : 'none';
      parentItem.querySelector('.submenu-arrow').style.transform = isOpen ? 'rotate(180deg)' : 'rotate(0)';
    }
  
    bindEvents() {
      window.addEventListener('resize', () => this.handleResize());
  
      // Empêcher la navigation sur les éléments parents en desktop et mobile
      this.menuItems.forEach(item => {
        const link = item.querySelector('a');
        link.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.isMobile) {
            this.handleMobileClick(e);
          }
        });
      });
    }
  
    handleResize() {
      const newIsMobile = window.innerWidth < 992;
      if (this.isMobile !== newIsMobile) {
        this.isMobile = newIsMobile;
        
        // Reset mobile-specific styles when switching to desktop
        if (!this.isMobile) {
          this.menuItems.forEach(item => {
            item.classList.remove('submenu-open');
            const subMenu = item.querySelector('.sub-menu');
            if (subMenu) {
              subMenu.style.display = '';
            }
            item.querySelector('.submenu-arrow').style.transform = '';
          });
        }
      }
    }
  }
  
  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', () => {
    new MenuHandler();
  });